import * as React from 'react';
interface ICreditCard {
    style?: {}; // inline style obj
    color?: string; // #000000
}
const CreditCard: React.FC<ICreditCard> = (props) => {
    const { color } = props;
    return (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            <defs>
                <path
                    d="M14.857 0H1.143C.51 0 0 .632 0 1.412v9.176C0 11.368.51 12 1.143 12h13.714C15.49 12 16 11.368 16 10.588V1.412C16 .632 15.49 0 14.857 0zm0 10.588H1.143v-4.94h13.714v4.94zm-2.024-2.47c.473 0 .857.474.857 1.058 0 .585-.384 1.06-.857 1.06a.77.77 0 01-.571-.282c-.152.17-.35.281-.572.281-.474 0-.857-.474-.857-1.059 0-.584.384-1.058.857-1.058.222 0 .42.11.572.28.152-.169.35-.28.571-.28zm2.024-6.706v2.117H1.143V1.412h13.714z"
                    id="CreditCard_a"
                />
            </defs>
            <use
                fill={color}
                fillRule="nonzero"
                xlinkHref="#CreditCard_a"
                transform="translate(0 2)"
            />
        </svg>
    );
};

export default CreditCard;
